<template>
  <v-container fluid>
    <subHeader />
    <!-- {{ enableButton() }} -->
    <v-container fluid style="max-width: 1266px">
      <v-row justify="center">
        <v-col cols="12" style="padding: 0; margin-bottom: 14px">
          <v-img
            max-width="1266"
            min-height="345"
            style="background-size: cover; background-position: center center"
            :src="$bucket + '/image/dashboard-tiles/NZUA_Landing_Hero.jpeg'"
          />
        </v-col>
        <!-- https://duonz-stage.s3.ap-southeast-2.amazonaws.com/image/dashboard-tiles/utah-santamonica.png -->
      </v-row>
      <v-row>
        <div style="width: 1266px; padding-top: 2rem; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0;">
            Sell Air New Zealand & United Airlines and be in to win a trip of a lifetime!
          </h2>
          <v-img :src="$bucket + '/image/dashboard-tiles/utah-santamonica.png'" max-width="250"/>
        </div>
        <div style="width: 75% !important; ">
          <p>
            Your favourite JV partners are back with an unforgettable opportunity: a spot on our exclusive <b>March 2026 Famil</b> to the USA with <b>Air New Zealand</b> and <b>United Airlines!</b>
          </p>
          <div>
            <span style="font-size:17px">Over the next eight weeks, log your eligible bookings and you could be one of eight lucky agents joining us on the ground in <b>Santa Monica & Utah for “Greatest Snow on Earth” and the Road to the National Parks.</b></span>
          </div>
        </div>
        <div style="width: 1266px !important; padding-bottom: 1rem; padding-top: 2rem">
          <div style="background-color:#EEEEEE;padding:3vw; margin-bottom: 3vw;">
            <h2>How to enter</h2>
            <br>
            From <b>Friday 10 October 8am to Monday 1 December 2025</b>, log your bookings to be in the draw:
            <br><br>
            <ul>
              <li>
                Book and ticket Air New Zealand (086) or United Airlines (016) flights between New Zealand and the USA
              </li>
              <li style="margin-top: 10px;">
                Travel can be for any time, but bookings must be made and ticketed within the promo period
              </li>
              <li style="margin-top: 10px;">
                Each eligible booking = one stamp on your passport
              </li>
              <li style="margin-top: 10px;">
                The more stamps you collect, the better your chances!
              </li>
              <li style="margin-top: 10px;">
                Entries must be submitted by the booking agent
              </li>
              <li style="margin-top: 10px;">
                Be sure to enter the correct NZ PNR creation date for your entry to count
              </li>
            </ul>
            <br>
            <b>You’ll also need to complete both Travel Utah’s training programme which can be found <a @click="visitUtah">here</a> and the California STAR program which can be found <a @click="visitCalifornia">here</a></b>
          </div>

          <div style="background-color:#221551; color: white;" class="my-8">
            <v-row>
              <v-col cols="8" class="pt-8 mt-8 pl-8">
                <h1 class="ml-8">Learn about the <br>Air New Zealand / United Airlines alliance</h1>
                <br><br>
                <div class="ml-8 mr-8">Let us show you our alliance benefits from expanded U.S. connectivity, lounge access, loyalty earn rates, and baggage allowances. It’s a handy reference for understanding how our partnership enhances travel options and rewards for customers</div>
                <br>
                <span class="ml-8"><v-btn outlined elevation="0" class="btn-learn-more" @click="visit">Learn more</v-btn></span>
              </v-col>
              <v-col cols="4" class="pt-0 pb-0" style="margin-bottom: -0.66vw;">
                <v-img
                  :src="$bucket + '/image/dashboard-tiles/Skyline.jpeg'"
                  class="fill-height"
                  cover
                  height 
                ></v-img>
              </v-col>
            </v-row>
            <br>
          </div>

          <div style="background-color:#EEEEEE; padding:3vw;">
            <h2>What you’ll win</h2>
            <br>
            We’re keeping most of the itinerary under wraps, with more details to be released over the coming weeks….but here’s a sneak peek:
            <br><br>
            <ul>
              <li>
                A hosted spot on the <b>Air New Zealand & United Airlines Famil</b>; departing 16 March, and arriving back 27 March 2026. 
              </li>
              <li style="margin-top: 10px;">
                 Flights are covered by Air New Zealand and United Airlines, including taxes!
              </li>
              <li style="margin-top: 10px;">
                Twin-share accommodation
              </li>
              <li style="margin-top: 10px;">
                <b>6 nights in Utah; travelling from Salt Lake City through snowy National Parks, to Las Vegas</b>
              </li>
              <li style="margin-top: 10px;">
                <b>3 nights in Santa Monica</b>
              </li>
            </ul>
            <br>
            <p style="font-size: 13px">
              <a
                style="font-size: 13px; color: black; font-style: italic"
                :href="$window.location.origin + '/#/airnzuaJointVentureTC'"
                target="_blank"
                >Terms and conditions apply.</a
              >
            </p>
          </div>
          <div class="text-center" style="width: 80%; margin: auto;">
            <br>
            <p style="font-size:25px">
              Let’s make the last few months of 2025 unforgettable - get selling, get logging, and get ready to explore more of the USA with us.
            </p>
            <p style="font-size:25px">
              <b>The top eight agents with the most stamps will win!</b>
            </p>
          </div>
          <br/>
          <div class="text-center" style="width: 80%; margin: auto;">
              <v-btn outlined elevation="0" class="btn-learn-more" @click="$router.push('/reward')">Enter now</v-btn>
          </div>
        </div>
      </v-row>
      <br />
    </v-container>
  </v-container>
</template>

<style scoped>
h2 {
  font-family: "AirNZ Sans Regular";
  font-size: 22px;
}

p {
  margin-top: 18px;
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
}

li {
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
}

a,
li a {
  margin-top: 15px;
  font-family: "AirNZ Sans Regular";
  font-size: 17px;
  text-decoration: underline;
  color: #440099;
}

a:hover {
  color: #9b4ff7 !important;
}

.btn-learn-more {
	width: 162px !important;
	height: 46px !important;
	border: 1px solid white;
	background-color: white !important;
	border-radius: 4px;
	opacity: 1;
	color: black !important;
	text-transform: none !important;
	font-size: 17px !important;
	letter-spacing: 0px;
}

</style>

<script>
import subHeader from "./subHeader.vue";

export default {
  components: {
    subHeader,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    visit() {
        window.open('https://duonz.s3.ap-southeast-2.amazonaws.com/image/document/J018507_-_United_Airlines_Fact_Pack_v3.pdf', "_blank");
    },
    visitUtah() {
        window.open('https://travel.utah.gov/international-media-hub', "_blank");
    },
    visitCalifornia() {
        window.open('https://star.visitcalifornia.com/login', "_blank");
    },
  }
};
</script>
